<template>
  <div>
    <p :class="['field', { invalid: isForcedInvalid }]">
      <label for="languageselectlist" v-translate>Jazyk oznámení</label>
      <select
          id="languageselectlist"
          name="languageselectlist"
          @change="selectLanguage"
          v-model="tempSelectedLanguage"
          ref="translationlanguageselectorref"
      >
        <option
            v-for="language in existingLanguagesComp"
            :key="language.value"
            :value="language.value"
        >
          {{ language.text }}
        </option>
      </select>
    </p>
    <div class="language_selector">
      <a  v-if="$_updateActionAllowed"
          class="btn btn_grey btn_dropdown"
          :class="{ 'active': isAddLanguageOpen }"
          :title="'Jazyky' | translate"
          v-translate
          @click="onLanguagesButtonClick"
      >Jazyky</a>
      <div class="dropdown_content" :class="{ 'open': isAddLanguageOpen }">
        <ul>
          <list-checkbox-input
              v-for="language in languages"
              :name="language.text"
              :key="language.value"
              :id="language.value"
              :groupId="'translations'"
              :selectedEntities="existingLanguagesForListCheckbox"
              @input="select"
              ref="languagelistcheckboxref"
          >
            {{ language.text }}
          </list-checkbox-input>
        </ul>
        <p class="field">
          <input class="btn" type="submit" :value="'Uložit' | translate" @click.prevent="saveNewLanguages">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {processCheckboxListToggle} from "../../../../utils/helpers"

export default {
  name: 'translation-language-select',
  props: {
    languages: {
      type: Array,
      default() {
        return []
      }
    },
    selectedLanguage: {
      type: String,
      default: null
    },
    existingLanguages: {
      type: Array,
      default: []
    },
    shouldLoadDefaultLanguage: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.tempSelectedLanguage = this.selectedLanguage
    this.firstLoad = true
    if (this.shouldLoadDefaultLanguage) {
      this.loadDefaultLanguage()
    }
  },
  data() {
    return {
      isAddLanguageOpen: false,
      selectedRadioBtn: null,
      tempSelectedLanguage: null,
      forcedInvalid: false,
      existingLanguagesNew: []
    }
  },
  computed: {
    languagesToSelect() {
      return this.languages
          .reduce((obj, v) => {
            obj[v.value] = {
              value: v.value,
              text: v.text
            }
            return obj
          }, {})
    },
    existingLanguagesComp() {
      return this.existingLanguages
    },
    existingLanguagesForListCheckbox() {
      let languages = []
      for (let i in this.existingLanguages) {
        languages.push(this.existingLanguages[i].value)
      }
      return languages
    },
    isForcedInvalid() {
      return this.forcedInvalid
    }
  },
  methods: {
    saveNewLanguages() {
      this.isAddLanguageOpen = false
      this.$emit('languagesSelectionChanged', this.existingLanguagesNew)
    },
    addLanguage(language) {
      if (language !== null) {
        this.existingLanguagesNew.push(language)
      }
    },
    deleteLanguage(language) {
      if (language !== null) {
        const index = this.existingLanguagesNew.findIndex(item => item.value === language.value)
        if (index > -1) {
          this.existingLanguagesNew.splice(index, 1)
        }
      }
    },
    selectLanguage() {
      this.$emit('selectLanguage', this.tempSelectedLanguage)
    },
    setForcedInvalid(value = false) {
      this.forcedInvalid = value
    },
    select(data) {
      if (data.checked) {
        this.addLanguage({text: data.id, value: data.id})
      } else {
        this.deleteLanguage({text: data.id, value: data.id})
      }
    },
    clearExistingLanguagesNew() {
      this.existingLanguagesNew = []
      for (let i in this.existingLanguages) {
        this.existingLanguagesNew.push(this.existingLanguages[i])
      }
      this.forceUpdateListCheckbox()
    },
    onLanguagesButtonClick() {
      this.isAddLanguageOpen = !this.isAddLanguageOpen
    },
    forceUpdateListCheckbox() {
      this.$refs['languagelistcheckboxref'].forEach(item => {
        item.$forceUpdate()
      })
    },
    loadDefaultLanguage() {
      if (this.firstLoad) {
        if (this.$props.existingLanguages.length === 0) {
          this.select({checked: true, id: this.$language.current.toLowerCase()})
          this.selectLanguage(this.$language.current.toLowerCase())
          this.saveNewLanguages()
        }

        this.firstLoad = false
      }
    },
  },
  watch: {
    selectedLanguage(id) {
      this.tempSelectedLanguage = id
    },
    existingLanguages: function () {
      this.clearExistingLanguagesNew()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/messagetemplates/languanges/TranslationLanguageSelect.vue